import { useRef } from 'react';

// `hasItems` keeps a restored list (browser back) from being replaced by the
// full page spinner while its trailing page is refetched in the background.
export const useIsInitialLoading = (loading, hasItems = false) => {
  const isInitialLoading = useRef(true);
  isInitialLoading.current = isInitialLoading.current && loading && !hasItems;
  return isInitialLoading.current;
};
